import { getGeneralInformation } from "../../../services/general-information/general-information";
import { AdminUserInformation } from "../../../static-data/AdminUserInformation";

const userInformation = {
  state: {
    userInformation: null, // Agora controlado apenas pelo Vuex
  },

  mutations: {
    setUserInformation(state, user) {
      state.userInformation = user;
    },
    clear(state) {
      state.userInformation = null;
    },
  },

  actions: {
    async requestUserInformation({ commit }, user) {
      try {
        const userInformation = await getGeneralInformation(user);
        userInformation.nickname = userInformation.name
          ? userInformation.name.split(" ", 1)[0]
          : "Cooperado";

        commit("setUserInformation", userInformation);
        return userInformation;
      } catch (err) {
        console.error("requestUserInformation error:", err);
        throw err;
      }
    },

    setAdminUser({ commit }, userName) {
      const adminUser = { ...AdminUserInformation, crm: userName };
      commit("setUserInformation", adminUser);
    },

    clearUserInformation({ commit }) {
      commit("clear");
    },
  },

  getters: {
    getUserInformation: (state) => state.userInformation,
  },
};

export default userInformation;
